import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { TransactionFormSkeleton } from '../../components/TransactionForm';

import './AvtaleGiroDetailsSkeleton.scss';

interface Props {
    numberOfSkeletonItems?: number;
    isMobile?: boolean;
}

const AvtaleGiroDetailsSkeleton: React.FC<Props> = ({ isMobile = true, numberOfSkeletonItems = 5 }) =>
    isMobile ? (
        <div className={`avtalegirodetails-list__skeleton `}>
            <div className="avtalegirodetails-list__skeleton-title">
                <Skeleton height={25} width="30%" />
            </div>
            <ul className="avtalegirodetails-list__skeleton-list">
                {Array.from(Array(numberOfSkeletonItems)).map((_, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <li key={index} className="avtalegirodetails-list__skeleton-list-item">
                        <Skeleton className="avtalegirodetails-list__skeleton-receiver-name" height={14} width="15%" />
                        <Skeleton height={16} width="50%" />
                        {index < 2 && (
                            <Skeleton
                                className="avtalegirodetails-list__skeleton-padding-bottom"
                                height={14}
                                width="40%"
                            />
                        )}
                        {index > 1 && (
                            <Skeleton
                                className="avtalegirodetails-list__skeleton-padding-bottom"
                                height={14}
                                width="0%"
                            />
                        )}
                    </li>
                ))}
            </ul>
            <div className="avtalegirodetails-list__skeleton-button">
                <Skeleton height={32} width={90} />
            </div>
        </div>
    ) : (
        <TransactionFormSkeleton withOwnText={false} titleClassName="avtalegirodetails-list__skeleton-title" />
    );

export default AvtaleGiroDetailsSkeleton;
